class DCopyCode extends HTMLElement {
  constructor() {
    super();
    
    // Додаємо обробник кліку
    this.addEventListener('click', this.handleClick.bind(this));
    
    // Початковий стан (опціонально)
    this._wasClicked = false;
  }

  handleClick() {
    const code = this.getAttribute('data-discount');
    
    if (!code) {
      console.warn('Атрибут data-discount відсутній');
      return;
    }

    navigator.clipboard.writeText(code)
      .then(() => {
        const original = this.querySelector('span').textContent.trim();
        
        this.querySelector('span').textContent = 'Copied!';
        this.style.cursor = 'default';
        this.style.userSelect = 'none';

        setTimeout(() => {
          this.querySelector('span').textContent = original;
          this.style.color = '';
          this.style.cursor = 'pointer';
          this.style.userSelect = '';
        }, 2000);
      })
      .catch(err => {
        console.error('Помилка копіювання:', err);
        this.querySelector('span').textContent = 'Error';
        setTimeout(() => this.querySelector('span').textContent = code, 2000);
      });
  }

  // Якщо атрибут data-discount зміниться — можна реагувати (опціонально)
  static get observedAttributes() {
    return ['data-discount'];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'data-discount' && oldValue !== newValue) {
      // наприклад, оновити текст, якщо він був порожній
      if (!this.textContent.trim()) {
        this.textContent = newValue;
      }
    }
  }
}

// Реєструємо кастомний елемент
customElements.define('d-code', DCopyCode);